import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const textRecipeDefaultVariants = {
  "titleEmphasis": "DEFAULT",
  "bodyEmphasis": "DEFAULT",
  "supplementalEmphasis": "DEFAULT",
  "hierarchy": "title"
}
const textRecipeCompoundVariants = []

const textRecipeSlotNames = [
  [
    "title",
    "text__title"
  ],
  [
    "body",
    "text__body"
  ],
  [
    "supplemental",
    "text__supplemental"
  ]
]
const textRecipeSlotFns = /* @__PURE__ */ textRecipeSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, textRecipeDefaultVariants, getSlotCompoundVariant(textRecipeCompoundVariants, slotName))])

const textRecipeFn = memo((props = {}) => {
  return Object.fromEntries(textRecipeSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const textRecipeVariantKeys = [
  "titleEmphasis",
  "bodyEmphasis",
  "supplementalEmphasis",
  "hierarchy"
]
const getVariantProps = (variants) => ({ ...textRecipeDefaultVariants, ...compact(variants) })

export const textRecipe = /* @__PURE__ */ Object.assign(textRecipeFn, {
  __recipe__: false,
  __name__: 'textRecipe',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: textRecipeVariantKeys,
  variantMap: {
  "titleEmphasis": [
    "DEFAULT",
    "strong",
    "muted"
  ],
  "bodyEmphasis": [
    "DEFAULT",
    "strong",
    "muted"
  ],
  "supplementalEmphasis": [
    "DEFAULT",
    "strong",
    "muted"
  ],
  "hierarchy": [
    "splash",
    "title",
    "subtitle"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, textRecipeVariantKeys)
  },
  getVariantProps
})